"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelResponseModelConcurrencyGroup = void 0;
exports.ModelResponseModelConcurrencyGroup = {
    Standard: "standard",
    Turbo: "turbo",
};
